export function formatUOM(value, metric, convertToPercentage) {
  if (metric.toLowerCase().includes("area")) {
    return value + "m²";
  }

  if (value.toString().toLowerCase().includes("0.") && convertToPercentage) {
    return value * 100 + "%";
  }

  return value;
}

export function divideByTenAndConstrain(inputNumber) {
  // Ensure the input is a number. If not, return an error or a default value.
  if (typeof inputNumber !== "number" && isNaN(inputNumber)) {
    console.error("Invalid input: Please provide a valid number.");
    return null; // Or throw an error, or return a default like 0.
  }

  let result = inputNumber / 10;

  // Constrain the result to be between 0 and 20.
  // Math.max ensures the result is not less than 0.
  // Math.min ensures the result is not greater than 20.
  if (result > 50 && result !== Infinity) {
    result = divideByTenAndConstrain(result);
  }

  return result;
}
